import { configureStore, combineReducers } from '@reduxjs/toolkit';
import userReducer from '../features/user/userSlice';
import programReducer from '../features/program/programSlice';
import userProgramReducer from '../features/userprograms/userProgramSlice';
import reportsReducer from '../features/reports/reportsSlice';
import helpReducer from '../features/help/helpSlice';
import userListReducer from '../features/userList/userListSlice';
import taskReducer from '../features/task/taskSlice';
import profileReducer from '../features/profile/profileSlice';
import activityReducer from '../features/activities/activitySlice';
import requestReducer from '../features/request/requestSlice';
import memberReducer from '../features/members/memberSlice';
import categoryReducer from '../features/category/categorySlice';
import { rtkQueryApiServices } from '../services/api';
import loginApiSlice from '../features/login/loginapi.services';
import mentorRegistrationApiSlice from '../features/mentorRegistrationForm/mentorRegistrationForm.services'
import menteeRegistrationApiSlice from '../features/menteeRegistrationForm/menteeRegistrationForm.services'

const combinedReducer = combineReducers({
  userInfo: userReducer,
  programInfo: programReducer,
  profileInfo: profileReducer,
  userPrograms: userProgramReducer,
  reports: reportsReducer,
  help: helpReducer,
  userList: userListReducer,
  requestList: requestReducer,
  tasks: taskReducer,
  activity: activityReducer,
  members: memberReducer,
  category: categoryReducer,
  [loginApiSlice.reducerPath]: rtkQueryApiServices.reducer,
  [rtkQueryApiServices.reducerPath]: rtkQueryApiServices.reducer,
  [menteeRegistrationApiSlice.reducerPath]: menteeRegistrationApiSlice.reducer,
  [mentorRegistrationApiSlice.reducerPath]: mentorRegistrationApiSlice.reducer,
});

const rootReducer = (state, action) => {
  if (action.type === 'logout') {
    //We are calling this RESET, but call what you like!
    state = undefined;
  }
  return combinedReducer(state, action);
};

export const store = configureStore({
  reducer: rootReducer,
  // [ticketsApi.reducerPath]: ticketsApi.reducer,

  middleware: (getDefaultMiddleware) => [
    ...getDefaultMiddleware()
      .concat(rtkQueryApiServices.middleware,loginApiSlice.middleware,
      menteeRegistrationApiSlice.middleware,
      mentorRegistrationApiSlice.middleware)

  ],
});
